import { RecordState } from './RecordState';
import { AidType } from './AidType';
import { PaymentMethod } from './PaymentMethod';
import { AidTargetContext } from './AidTargetContext';
var AidTargetPaymentDataWrapper = /** @class */ (function () {
    function AidTargetPaymentDataWrapper(_paymentData) {
        this._paymentData = _paymentData;
    }
    AidTargetPaymentDataWrapper.prototype.showERPROption = function () {
        return this.allowPaymentRequestOption() || this.allowExpenseReportOption();
    };
    AidTargetPaymentDataWrapper.prototype.allowPaymentRequestOption = function () {
        return this._paymentData.withdrawableAmount != 0
            && this.isPaymentRequestInValidState(this._paymentData.paymentRequestState)
            && !this._paymentData.paymentBan
            && !this._paymentData.oldPaymentAndExpenseNotAllowed;
    };
    AidTargetPaymentDataWrapper.prototype.allowExpenseReportOption = function () {
        return this.isPaymentRequestInValidState(this._paymentData.expenseReportState)
            && (this._paymentData.aidType === AidType.B || this._paymentData.hasUnclearedAmount)
            && !this._paymentData.oldPaymentAndExpenseNotAllowed;
    };
    AidTargetPaymentDataWrapper.prototype.aidTargetContext = function () {
        var aidTargetContext = new AidTargetContext();
        aidTargetContext.aidTargetId = this._paymentData.aidTargetId;
        aidTargetContext.aidTargetNumber = this._paymentData.aidTargetNumber;
        aidTargetContext.aidType = this._paymentData.aidType;
        return aidTargetContext;
    };
    AidTargetPaymentDataWrapper.prototype.isPaymentRequestInValidState = function (state) {
        var invalidStates = [RecordState.New, RecordState.OpenInWeb, RecordState.SentFromWeb];
        return this._paymentData.paymentMethod === PaymentMethod.PaymentRequest && !invalidStates.includes(state);
    };
    return AidTargetPaymentDataWrapper;
}());
export { AidTargetPaymentDataWrapper };
